export default "__VITE_ASSET__D9T5Frea__"